import { useMutation } from '@apollo/client';
import { metrics } from '@seek/metrics-js';

import { useAppConfig } from 'src/components/App/useAppConfig';
import type { ReportJobInput } from 'src/global';
import { CreateReportedJobDocument } from 'src/graphql/graphql';
import logger from 'src/modules/logger';

const useReportJob = () => {
  const [createReportedJob] = useMutation(CreateReportedJobDocument);

  const { country } = useAppConfig();
  const reportJob = async (
    reportJobInput: Pick<
      ReportJobInput,
      'jobId' | 'comment' | 'email' | 'reason'
    >,
  ) => {
    const startTime = Date.now();
    const endpointName = 'report-job';
    const isUpstream = true;

    // only support ANZ and NZ
    const { data, errors } = await createReportedJob({
      variables: {
        report: {
          country,
          ...reportJobInput,
        },
      },
    });
    if (data?.reportJob.success) {
      metrics.httpRequestTiming({
        status: 200,
        duration: Date.now() - startTime,
        isUpstream,
        endpointName,
      });
      return true;
    }

    errors?.forEach((error) => {
      logger('Failed to create reported job', { error });
    });

    if (errors?.length) {
      metrics.httpRequestTiming({
        status: 400,
        duration: Date.now() - startTime,
        isUpstream,
        endpointName,
      });
    }
    return false;
  };

  return {
    reportJob,
  };
};

export default useReportJob;
